import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';
import ItemsContainer from '../../vue/marketplace/items/container.vue';

Vue.prototype.i18n = window.i18n;
Vue.use(TurbolinksAdapter);

if (window.itemsComponent) {
  window.itemsComponent.$destroy(true);
}

window.itemsComponent = new Vue({
  el: '#items-index',
  components: { ItemsContainer }
});
